module.exports = __webpack_public_path__ + "static/img/release-success.52c7412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/release-success.png
// module id = YmzF
// module chunks = 1